/**
 * Frontend Application Configuration
 * Contains exact literal configuration values bundled directly into production assets during `npm run build`.
 */

export const APP_CONFIG = {
  // 1. API Endpoints
  // BASE_URL: "https://187.127.189.185",
  // BASE_URL: "http://localhost:8080",
    BASE_URL: "https://www.rlnpbahadura.in",

  // 2. Azure Blob Storage
  AZURE_STORAGE_ACCOUNT_NAME: "gunthewariqa",
  AZURE_CONTAINER_NAME: "cp-bpms-qa",
  AZURE_SAS_TOKEN:
    "sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-12-31T18:17:53Z&st=2026-01-02T10:02:53Z&spr=https,http&sig=iZfVjBQYQ%2BEqCasoEZZP%2B0TQQlvRtgoDuZVb5ZH7fz4%3D",
  AZURE_VALIDATION_DOMAIN_REGEX:
    "^https:\\/\\/(gunthewariqa|besaprodguntheweari)\\.blob\\.core\\.windows\\.net\\/.*\\.(jpg|jpeg|png|pdf|doc|docx)(\\?.*)?$",

  // 3. Municipal & Branch Metadata
  TENANT_ID: "001",
  BRANCH_NAME: "QA-Bahadura-v1.0",
  MUNICIPALITY_FULL_NAME: "Nagar Panchayat Bahadura",

  // 4. Third-Party Keys
  RECAPTCHA_SITE_KEY: "6Ldy7j0sAAAAAK96npJL_p3ghiggm7ew8TN4V6U2",

  // 5. Feature Flags
  ENABLE_CONSTRUCTION_QUESTION: false, // Set to true to enable "Is there a construction?" Yes/No dropdown
  ENABLE_BAHADURA_PLOT_DEMAND_NOTE_CHARGES: true, // Set to true to use the new 8-item Bahadura Plot Demand Note charges instead of the legacy 2-particular form/template
  ENABLE_BAHADURA_CERTIFICATE_FIELDS: true, // Set to true to use the new Bahadura certificate template with Layout Holder / Ownership Document fields (independent of the Demand Note charges flag)
  ENABLE_BAHADURA_CERTIFICATE_LOCK: true, // Set to true to permanently lock (remove the pencil edit toggle from) every editable field on the L2/L3 Certificate screens except Applicant Name. Certificate screens only -- Demand Note screens are unaffected.
} as const;

export default APP_CONFIG;
